import มรดก from "./posts-islam/มรดก";
import ทายาทอิส from "./posts-islam/ทายาทอิส";
import คำนวณ from "./posts-islam/คำนวณ";
import กรณีพิเศษ from "./posts-islam/กรณีพิเศษ";
import อายัต from "./posts-islam/อายัต";
import พินัยกรรมอิส from "./posts-islam/พินัยกรรมอิส";
import img1 from "../../assets/islam/img-title/กฎหมายมรดก.png";
import img2 from "../../assets/islam/img-title/ทายาท.png";
import img3 from "../../assets/islam/img-title/คำนวณ.png";
import img4 from "../../assets/islam/img-title/พิเศษ.png";
import img5 from "../../assets/islam/img-title/พินัยกรรม.png";
import imgุ6 from "../../assets/islam/img-title/อายัต.png";

export const islamData = [
  {
    id: 1,
    title: "ความรู้ทั่วไปของกฎหมายมรดกอิสลาม", 
    category: "ความรู้ทั่วไป",
    subCategory: ["ข้อมูลทั่วไป"],
    description:
      "กฎหมายมรดก ( الفرائض) ในศาสนาอิสลามได้กำหนดให้ทั้งชายและหญิงสามารถถือกรรมสิทธิ์ได้ ภายใต้ข้อกำหนดและกฎเกณฑ์ของอิสลาม ซึ่งพระมหาคัมภีร์อัลกุรอานได้อธิบายถึงเกณฑ์ต่างๆ ของการแบ่งมรดก สถานะภาพของผู้รับมรดกอย่างครบถ้วนสมบูรณ์ โดยมิได้ปล่อยช่องว่างไว้ให้ผู้หนึ่งผู้ใดทำการกำหนดการแบ่งมรดกได้ด้วยตนเอง",
    content: <มรดก />,
    cover: img1,
  },
  {
    id: 2,
    title: "ทายาทที่มีสิทธิและเสียสิทธิรับมรดก",
    category: "ทายาทที่มีสิทธิและเสียสิทธิ",
    subCategory: ["ทายาทที่มีสิทธิ", "ทายาทที่เสียสิทธิ"],
    description:
      "ทายาท หมายถึง บุคคลที่มีสิทธิรับมรดกของผู้ตาย แต่ไม่รวมถึงผู้รับพินัยกรรม โดยผู้ที่เป็นทายาทของผู้ตายจะต้องมีคุณสมบัติที่ถูกกำหนดไว้",
    content: <ทายาทอิส />,
    cover: img2,
  },
  {
    id: 3,
    title: "วิธีการคำนวณมรดกอิสลาม",
    category: "การคำนวณ",
    subCategory: ["การคำนวณ"],
    description:
      "วิธีการคำนวณมรดกอิสลาม มีความสำคัญและจำเป็นอย่างมาก เนื่องจากมีเงื่อนไขและกฎเกณฑ์ของทายาทแต่ละรายแตกต่างกันออกไป และยังมีตัวเลขเศษส่วน และการบวกเศษส่วนเข้ามาเกี่ยวข้องด้วย ",
    content: <คำนวณ />,
    cover: img3,
  },
  {
    id: 4,
    title: "การแบ่งมรดกกรณีพิเศษ",
    category: "ความรู้ทั่วไป",
    subCategory: ["ผู้ที่หายสาบสูญ", "บุตรนอกสมรส"],
    description:
      "การแบ่งมรดกกรณีพิเศษ ทางผู้จัดทำได้แบ่งออกเป็น 9 หัวข้อ ตามแหล่งอ้างอิงที่ได้ศึกษาไว้ ดังต่อไปนี้",
    content: <กรณีพิเศษ />,
    cover: img4,
  },
  {
    id: 5,
    title: "บทบัญญัติที่ถูกกล่าวถึงในกฎหมายมรดก",
    category: "บทบัญญัติ",
    subCategory: ["บทบัญญัติ"],
    description:
      "บทบัญญัติที่ถูกกล่าวถึงในกฎหมายมรดกมีเป็นจำนวนมาก เนื่องจาก อัลลอฮฺ (ซ.บ.) ต้องการให้ความกระจ่างแก่มนุษย์ โดยมิปล่อยช่องว่างให้ผู้ใดผู้หนึ่งดำเนินการแบ่งมรดกด้วยตนเอง",
    content: <อายัต />,
    cover: imgุ6,
  },
  {
    id: 6,
    title: "พินัยกรรม",
    category: "พินัยกรรม",
    subCategory: ["พินัยกรรม"],
    description: "พินัยกรรม (วะศิยะฮฺ) ตามคำนิยามของนักกฎหมายอิสลามหมายถึง การยกกรรมสิทธิ์ให้กับผู้อื่นทีมีผลภายหลังจากการตายโดยความเสน่หา ไม่ว่าจะเป็นจะเป็นวัตถุหรือผลประโยชน์ก็ตาม",
    content: <พินัยกรรมอิส />,
    cover: img5,
  },
];
